<template>
  <div :class="isPC ? 'invite-error': 'invite-error-mobile'" id='invite-error'>
    <Icon></Icon>
    <div class="text">
      <p class="title">{{text1}}</p>
      <p class="content">{{text2}}</p> 
      <p class="title">{{text3}}</p> 
      <p class="content">{{text4}}</p> 
      <p class="content">{{text5}}</p>  
    </div>
    <Buttons :type="'tosignup'" style="width: 200px;margin-top: 50px;"></Buttons>
  </div>
</template>

<script>
  import Icon from '../components/Icon'
  import Buttons from '../components/Buttons'
  import translate from '../common/Translate.js'
  import { checkDevice } from '../common/Common.js'
  export default {
    data () {
      return {
        isPC: checkDevice(),
        text1: translate('inviteErrorText1'),
        text2: translate('inviteErrorText2'),
        text3: translate('inviteErrorText3'),
        text4: translate('inviteErrorText4'),
        text5: translate('inviteErrorText5')
      }
    },
    components: {
      Icon, Buttons
    },
    created () {
    },
    mounted () {
      if (!this.isPC) {
        // Icon margin top 50 need to calc.
        let inviteError = document.getElementById('invite-error')
        let topHeight = (window.screen.height - inviteError.offsetHeight + 50) / 3
        // console.log(topHeight)
        inviteError.style.top = topHeight - 50 + 'px'
      }
    }
  }
</script>

<style lang="less" scoped>
  @import '../../assets/css/_mixin.less';
  .invite-error {
    .white-bg();
    height: 520px;
    margin-top: -260px;
    .text {
      width: 300px;
      margin: 0 auto;
      margin-top: 40px;
      line-height: 20px;
      text-align: left;
      .title {
        font-size: 16px;
        font-weight: bold;
        color: #3e3e3e;
        margin-bottom: 20px;
        margin-top: 20px;
      }
      .content {
        font-size: 14px;
        color: #939699;
      }
    }
  }
  .invite-error-mobile {
    .white-mobile-bg();
    min-height: 425px;
    .text {
      width: 300px;
      margin: 0 auto;
      margin-top: 40px;
      line-height: 20px;
      text-align: left;
      .title {
        font-size: 16px;
        font-weight: bold;
        color: #3e3e3e;
        margin-bottom: 20px;
        margin-top: 20px;
      }
      .content {
        font-size: 14px;
        color: #939699;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Inviteerror.vue?d1129990